// extracted by mini-css-extract-plugin
export default {"loginButton":"sso-buttons_loginButton__oMQ6m","oktaLoginMulti":"sso-buttons_oktaLoginMulti__siOjz"};